// Components==============
import { motion } from 'framer-motion';
import React from 'react';
// =========================

const WaterFall = React.memo(() => (
    <>
        <defs>
            <clipPath id="clippath-24">
                <polygon
                    points="5031.2 1880.6 4881.2 1968.4 4880.4 2489 5031.2 2401.6 5031.2 1880.6"
                    fill="none"
                />
            </clipPath>
        </defs>
        <polygon
            points="5031.2 1880.6 4881.2 1968.4 4880.4 2489 5031.2 2401.6 5031.2 1880.6"
            fill="#526df5"
        />
        <g clipPath="url(#clippath-24)">
            <motion.path
                animate={{
                    y: [-600, 600, -600],
                }}
                transition={{
                    y: {
                        duration: 12,
                        times: [0, 1, 1],
                        repeat: Infinity,
                        repeatType: 'loop',
                        ease: 'linear',
                    },
                }}
                d="M5031.2,1962.9c0-4.6-6.8-5-7.3-.5l-13.1,105.4c-.6,4.5-7.3,4.2-7.3-.4l-2.8-101.4c0-4.6-6.9-4.9-7.3-.3l-6.6,68c-.5,4.6-7.3,4.3-7.3-.4v-87.4c0-4.7-7-5-7.3-.2l-3.3,71c-.1,2.2-1.8,4-4,4.3-2.4.3-4.6-1.5-4.9-3.9l-3.3-27.1c0-1.3-1.1-2.3-2.3-2.4-1.4-.1-2.7,1-2.7,2.4l-1.3,57.1c0,3-2.5,5.4-5.5,5.4s-5.4-2.3-5.5-5.3l-2.5-62.7c-.3-4.7-7.3-4.5-7.3.2v103.1c0,4.7-6.8,5-7.3.4l-7.8-74.9c-.5-4.6-7.2-4.3-7.3.3l-5.8,110.9c-.1,4.6-6.9,4.8-7.3.2l-5-54.4c-.4-4.7-7.5-4.4-7.5.3l-.4,275.9c0,4.6,7.3,5.2,7.9.6l13.1-105.4c.6-4.5,7.3-4.2,7.3.4l2.8,199.2c0,4.6,6.9,4.9,7.3.3l6.6-68c.5-4.6,7.3-4.3,7.3.4v87.4c0,4.7,7,5,7.3.2l3.9-124.6c0-1.4.8-2.7,2-3.4l.9-.6c2.8-1.8,6.4.2,6.5,3.5l1.4,57c0,2.7,3.1,4.3,5.4,2.9,1-.6,1.6-1.7,1.6-2.8l2.3-69.2c0-1.4.8-2.7,2-3.4,2.8-1.7,6.4.2,6.5,3.4l3.2,98.5c.3,4.7,7.3,4.5,7.3-.2v-103.1c0-4.7,6.8-5,7.3-.4l7.8,74.9c.5,4.6,7.2,4.3,7.3-.3l5.8-208.8c.1-4.6,6.9-4.8,7.3-.2l5,54.4c.4,4.7,7.3,4.3,7.3-.3v-276.1Z"
                fill="#4262e9"
            />
            <motion.path
                animate={{
                    y: [-600, 600, -600],
                }}
                transition={{
                    y: {
                        duration: 12,
                        times: [0, 1, 1],
                        repeat: Infinity,
                        repeatType: 'loop',
                        ease: 'linear',
                        delay: 6,
                    },
                }}
                d="M5031.2,1962.9c0-4.6-6.8-5-7.3-.5l-13.1,105.4c-.6,4.5-7.3,4.2-7.3-.4l-2.8-101.4c0-4.6-6.9-4.9-7.3-.3l-6.6,68c-.5,4.6-7.3,4.3-7.3-.4v-87.4c0-4.7-7-5-7.3-.2l-3.3,71c-.1,2.2-1.8,4-4,4.3-2.4.3-4.6-1.5-4.9-3.9l-3.3-27.1c0-1.3-1.1-2.3-2.3-2.4-1.4-.1-2.7,1-2.7,2.4l-1.3,57.1c0,3-2.5,5.4-5.5,5.4s-5.4-2.3-5.5-5.3l-2.5-62.7c-.3-4.7-7.3-4.5-7.3.2v103.1c0,4.7-6.8,5-7.3.4l-7.8-74.9c-.5-4.6-7.2-4.3-7.3.3l-5.8,110.9c-.1,4.6-6.9,4.8-7.3.2l-5-54.4c-.4-4.7-7.5-4.4-7.5.3l-.4,275.9c0,4.6,7.3,5.2,7.9.6l13.1-105.4c.6-4.5,7.3-4.2,7.3.4l2.8,199.2c0,4.6,6.9,4.9,7.3.3l6.6-68c.5-4.6,7.3-4.3,7.3.4v87.4c0,4.7,7,5,7.3.2l3.9-124.6c0-1.4.8-2.7,2-3.4l.9-.6c2.8-1.8,6.4.2,6.5,3.5l1.4,57c0,2.7,3.1,4.3,5.4,2.9,1-.6,1.6-1.7,1.6-2.8l2.3-69.2c0-1.4.8-2.7,2-3.4,2.8-1.7,6.4.2,6.5,3.4l3.2,98.5c.3,4.7,7.3,4.5,7.3-.2v-103.1c0-4.7,6.8-5,7.3-.4l7.8,74.9c.5,4.6,7.2,4.3,7.3-.3l5.8-208.8c.1-4.6,6.9-4.8,7.3-.2l5,54.4c.4,4.7,7.3,4.3,7.3-.3v-276.1Z"
                fill="#4262e9"
            />
        </g>
        <polygon
            points="4948.4 2113.2 4944.5 2450 4973.9 2429.5 4967.4 2116.4 4948.4 2113.2"
            fill="#526df5"
        />
        <g>
            <polygon
                points="4944.5 2107 4961 2102.2 4973.8 2102.5 4961 2111 4944.5 2107"
                fill="#eacfb5"
            />
            <polygon
                points="4961 2174.6 4973.8 2102.5 4961 2102.2 4961 2174.6"
                fill="#cfa878"
            />
            <polygon
                points="4944.5 2107 4961 2102.2 4961 2174.6 4944.5 2107"
                fill="#e9bf99"
            />
            <polygon
                points="4961 2174.6 4973.8 2102.5 4961 2111 4961 2174.6"
                opacity="0"
            />
            <polygon
                points="4944.5 2107 4961 2102.2 4973.8 2102.5 4961 2111 4944.5 2107"
                fill="#eacfb5"
            />
        </g>
        <polygon
            points="4961 2174.6 4973.8 2102.5 4961 2111 4961 2174.6"
            opacity="0"
        />
    </>
));

WaterFall.displayName = 'WaterFall';
export default WaterFall;
